




import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { Chart, registerables } from 'chart.js'
Chart.register(...registerables)

@Component({})
export default class ChartLine extends Vue {
  @Prop()
  data: any

  @Prop()
  chartOptions: any

  chart: any | null

  mounted() {
    this.chart = new Chart(
      this.$refs['chart'] as any,
      {
        type: 'line',
        data: this.data,
        options: this.chartOptions
      }
    );
  }

  @Watch('data', {deep: true})
  dataChange(){
    if (this.chart) {
      this.chart.data = this.data
      this.chart.update()
    }
  }
}
